<div class="di-mobile-menu-wrapper">
  <div class="mobile-menu-data">
    <div class="profile-header-wrapper">
      <div class="user-profile">
        <div class="profile-image">
          <div class="name-tag">{{ userName?.substring(0, 1) }}</div>
        </div>
        <div class="user-details">
          <h4>{{ userName }}</h4>
          <p *ngIf="userEmail">{{ userEmail }}</p>
          <div class="edit-logout-links">
            <a (click)="editProfile()">Edit Profile</a>
            <!--<a href="">Log Out</a>-->
          </div>
        </div>
        <!-- .user-details ends here -->
        <button class="closeMenu" (click)="closeMobileMenu()">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>

      <products-dropdown [viewFrom]="'mobile'" [showMobileMenu]="showMobileMenu"></products-dropdown>
    </div>

    <app-menu (click)="closeMobileMenu()"></app-menu>
  </div>

  <div class="mobile-menu-bg" (click)="closeMobileMenu()"></div>
</div>